import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=004b5053&scoped=true"
import script from "./Created.vue?vue&type=script&lang=ts"
export * from "./Created.vue?vue&type=script&lang=ts"
import style0 from "./Created.vue?vue&type=style&index=0&id=004b5053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b5053",
  null
  
)

export default component.exports